import React, { useState } from "react";
import { Alert, Button, Divider, Menu, MenuItem, Snackbar } from "@mui/material";
import useAuth from "../../../components/hooks/useAuth";
import { post_Payment } from "../../../services/Payment";
import { branchTimezone } from "../../../utils/summaryCalculation";
import SettledOutstandingBalance from "./SettledOutstandingBalance2";
import AddOfflinePayment from "./AddOfflinePayment2";
import ProcessPaymentBox from "./ProcessPaymentBox2";
import useConfirm from "../../../components/hooks/useConfirm";
import { useTheme } from "../../../components/hooks/useTheme";
import PaymentDetailsPopup from "./PaymentDetailsPopup2";
import PaymentRequest from "./PaymentRequest2";
import { paymentRequestStatusColorCode } from "../../../utils/statusColorCode";
import PaymentRequestDetails from "./PaymentRequestDetails2";
import colorConfigs from "../../../configs/colorConfigs";
import Cookies from "js-cookie";
import useTenant from "../../../components/hooks/useTenant";
import useAccessControl from "../../../components/hooks/useAccessControl";
import useGeneral from "../../../components/hooks/useGeneral";
import moment from "moment";

type Props = {
  formattedCreatedAt: string;
  allPaymentList: any[];
  allPaymentRequestList: any[];
  securityDepositAmount: number;
  isCompletedOrCancelled: boolean;
  reservationId: number;
  refundList: any[];
  preferredDateFormat: string;
  isSecurityDepositedPaid: boolean;
  isSecurityDepositedRefunded: boolean;
  creditCardList: any[];
  summaryData: any;
  refreshTheSummary: () => void;
  refreshThepayment: () => void;
  refreshThePaymentRequest: () => void;
  refreshThRefund: () => void;
  setPleaseWait: (value: boolean) => void;
};

export default function AddPayments({
  formattedCreatedAt,
  allPaymentList,
  allPaymentRequestList,
  securityDepositAmount,
  isCompletedOrCancelled,
  reservationId,
  refundList,
  preferredDateFormat,
  isSecurityDepositedPaid,
  isSecurityDepositedRefunded,
  creditCardList,
  summaryData,
  refreshTheSummary,
  refreshThepayment,
  refreshThePaymentRequest,
  refreshThRefund,
  setPleaseWait
}: Props) {
  const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
  const { themeStyles } = useTheme();
  const { auth }: any = useAuth();
  const { handleTenantError }: any = useTenant();
  const { dateFormat }: any = useGeneral();
  const { setConfirmPopup, setData: setConfirmData }: any = useConfirm();
  const { permissions }: any = useAccessControl();
  const [processPaymentBox, setProcessPaymentBox] = useState<boolean>(false);
  const [offlinePaymentPopup, setOfflinePaymentPopup] = useState<boolean>(false);
  const [isProcessPayment, setIsProcessPayment] = useState<boolean>(false);
  const [particularPaymentDetails, setParticularPaymentDetails] = useState<any | null>(null);
  const [isPaymentRequestType, setIsPaymentRequestType] = useState<boolean>(true);
  const [openPaymentDetailsPopup, setOpenPaymentDetailsPopup] = useState<boolean>(false);
  const [openPaymentRequestPopup, setOpenPaymentRequestPopup] = useState<boolean>(false);
  const [openPaymentRequestDetailsPopup, setOpenPaymentRequestDetailsPopup] = useState<boolean>(false);
  const [paymentRequestDetails, setPaymentRequestDetails] = useState<any | null>(null);
  const [showCopyPopup, setShowCopyPopup] = useState<boolean>(false);


  const [openSettledOutstandingDialog, setOpenSettledOutstandingDialog] = useState<boolean>(false);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (!isCompletedOrCancelled) {
      setSAnchorEl(null)
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const [sanchorEl, setSAnchorEl] = React.useState<null | HTMLElement>(null);
  const sopen = Boolean(sanchorEl);
  const shandleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (!isCompletedOrCancelled) {
      setAnchorEl(null)
      setSAnchorEl(event.currentTarget);
    }
  };

  const shandleClose = () => {
    setSAnchorEl(null);
  };

  const UpdateTimezone = branchTimezone(formattedCreatedAt);

  const handleAuthorize = async (isProcessPayment: boolean, id: number) => {
    if (!isCompletedOrCancelled) {
      setPleaseWait(true);

      let outstandingPayment = summaryData?.outstandingBalance || 0;

      await post_Payment({
        reservationId: reservationId,
        paymentType: isProcessPayment ? "Payment" : "Security Deposit",
        paymentMethod: "Credit Card",
        dateofPayment: new Date(UpdateTimezone).toLocaleString(),
        amount: isProcessPayment ? outstandingPayment : securityDepositAmount,
        reference: "",
        status: "",
        createdAt: new Date(UpdateTimezone).toLocaleString(),
        createdBy: auth.givenname,
        syncedWithAccounting: false,
        creditCardId: id
      }, auth?.id, tenantId)
        .then(() => {
          setOfflinePaymentPopup(false);
          refreshTheSummary();
          refreshThepayment();
          handleTenantError(null);
        })
        .catch((error) => {
          if (error?.response?.data?.includes("Declined")) {
            refreshThepayment();
          }
          setConfirmData({
            title: 'Warning',
            summary: error.response.data,
            confirmBtn: 'Ok',
            isConfirm: (callback: any) => {
              callback();
            }
          });

          setConfirmPopup(true);
          setPleaseWait(false);
          handleTenantError(error);
        });
    }
  }

  return (
    <>
      <div className="mb-4">
        <span className={`text-[14px] font-semibold inline-block mb-2 ${themeStyles.main.textHeadingColor}`}>
          Payments
        </span>

        <Divider className={`w-full ${themeStyles.divider.bg}`} />

        <div className="w-full my-2">

          <table className="min-w-full">
            <tbody className="text-left">
              <tr className={`border-b ${themeStyles.main.borderColor}`}>
                <th className={`w-[5%] text-[12px] font-semibold mb-2 py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>#</th>
                <th className={`w-[10%] text-[12px] font-semibold mb-2 py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Payment Type</th>
                <th className={`w-[12%] text-[12px] font-semibold mb-2 py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Payment Method</th>
                <th className={`w-[10%] text-[12px] font-semibold mb-2 py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Date</th>
                <th className={`w-[10%] text-[12px] font-semibold mb-2 py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Amount</th>
                <th className={`w-[10%] text-[12px] font-semibold mb-2 py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Reference</th>
                <th className={`w-[10%] text-[12px] font-semibold mb-2 py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Payment Status</th>
                <th className={`w-[12%] text-[12px] font-semibold mb-2 py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Created By</th>
                <th className={`w-[10%] text-[12px] font-semibold mb-2 py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Created at</th>
                <th className={`w-[10%] text-[12px] font-semibold mb-2 py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Synced with Accounting?</th>
              </tr>

              {
                allPaymentList?.map((item: any, index: number) => {
                  return (
                    <tr key={index} className={`border-b ${themeStyles.main.borderColor}`}>
                      <td className="py-2 w-[8%]">
                        <span
                          className={`text-xs font-medium ${(permissions?.disabledrefund || auth?.roles?.toLowerCase()?.trim() === "admin") ? "text-blue-500 underline cursor-pointer" : "cursor-default"} ${themeStyles.main.textHeadingColor}`}
                          onClick={() => {
                            if (permissions?.disabledrefund || auth?.roles?.toLowerCase()?.trim() === "admin") {
                              setOpenPaymentDetailsPopup(true);
                              setParticularPaymentDetails(item);
                            }
                          }}
                        >
                          {item?.id}
                        </span>
                      </td>

                      <td className="py-2 w-[10%]">
                        <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>{item?.paymentType}</span>
                      </td>

                      <td className="py-2 w-[12%]">
                        <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>{item?.paymentMethod}</span>
                      </td>

                      <td className="w-[10%]">
                        <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>
                          {
                            item?.dateofPayment
                              ? moment(
                                new Date(
                                  item?.dateofPayment
                                    ?.replaceAll("-", "/")
                                    ?.split("T")[0]
                                )
                              ).format(dateFormat)
                              : ""
                          }
                        </span>
                      </td>

                      <td className="py-2 w-[10%]">
                        <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>${parseFloat(item?.amount)?.toFixed(2)}</span>
                      </td>

                      <td className="py-2 w-[10%]">
                        <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>{item?.reference}</span>
                      </td>

                      <td className="py-2 w-[10%]">
                        <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>{item?.status}</span>
                      </td>

                      <td className="py-2 w-[10%]">
                        <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>{item?.createdBy}</span>
                      </td>

                      <td className="py-2 w-[10%]">
                        <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>
                          {
                            item?.createdAt
                              ? moment(new Date(item.createdAt)).format(dateFormat + " hh:mm a")
                              : ""
                          }
                        </span>
                      </td>

                      <td className="py-2 w-[10%]">
                        <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>{item?.syncedWithAccounting ? "Yes" : "No"}</span>
                      </td>
                    </tr>
                  )
                })
              }
            </tbody>
          </table>

          <div className="w-full flex items-center gap-2.5 mt-4">
            {
              (
                summaryData?.outstandingBalance > 0
                || (
                  !isSecurityDepositedPaid
                  && securityDepositAmount > 0
                )
              ) && (
                <Button variant="contained"
                  sx={{
                    backgroundColor: colorConfigs.btn.main.bg,
                    fontSize: "10px"
                  }}
                  onClick={() => {
                    if (!isCompletedOrCancelled)
                      if (summaryData?.outstandingBalance > 0 || (!isSecurityDepositedPaid && securityDepositAmount > 0)) {
                        setOfflinePaymentPopup(true)
                      } else {
                        setConfirmData({
                          title: 'Warning',
                          summary: "You do not have any Outstanding Balance",
                          confirmBtn: 'Ok',
                          isConfirm: (callback: any) => {
                            callback();
                          }
                        });

                        setConfirmPopup(true);
                      }
                  }}
                >
                  Add Offline Payment
                </Button>
              )
            }

            {
              creditCardList?.length > 0 && (
                <>
                  {
                    (
                      summaryData?.outstandingBalance > 0
                    ) && (
                      <>
                        <Button variant="contained"
                          sx={{
                            backgroundColor: colorConfigs.btn.main.bg,
                            fontSize: "10px"
                          }}
                          onClick={handleClick}
                        >
                          {/* Authorize -> is the Payment gateway we are using for payment */}
                          Pay ${parseFloat(summaryData?.outstandingBalance)?.toFixed(2)} with Authorize
                          {
                            open
                              ? (
                                <span className={`material-symbols-outlined text-white text-[20px] font-extralight`}>
                                  keyboard_arrow_up
                                </span>
                              ) : (
                                <span className={`material-symbols-outlined text-white text-[20px] font-extralight`}>
                                  keyboard_arrow_down
                                </span>
                              )
                          }
                        </Button>

                        <Menu
                          id="basic-menu"
                          anchorEl={anchorEl}
                          open={open}
                          onClose={handleClose}
                          slotProps={{
                            paper: {
                              sx: {
                                width: 230,
                                backgroundColor: themeStyles.topBar.bg
                              }
                            }
                          }}
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "left",
                          }}
                          transformOrigin={{
                            vertical: "top",
                            horizontal: "left",
                          }}
                        >
                          {
                            creditCardList?.map((item: any, i: number) => ([
                              <MenuItem
                                key={`${i}-Item`}
                                sx={{ fontSize: "12px", marginBlock: "0px" }}
                                onClick={() => {
                                  if (!isCompletedOrCancelled) {
                                    if (summaryData?.outstandingBalance > 0) {
                                      setConfirmData({
                                        title: 'Payment',
                                        summary: 'Are you sure you want to pay?',
                                        confirmBtn: 'Yes',
                                        isConfirm: (callback: any) => {
                                          handleAuthorize(true, item?.id);
                                          callback();
                                        }
                                      });

                                      setConfirmPopup(true);

                                      handleClose();
                                    } else {
                                      setConfirmData({
                                        title: 'Warning',
                                        summary: "You do not have any Outstanding Balance",
                                        confirmBtn: 'Ok',
                                        isConfirm: (callback: any) => {
                                          callback();
                                        }
                                      });

                                      setConfirmPopup(true);
                                    }
                                  }
                                }}
                              >
                                <span className={`${themeStyles.topBar.tailwindTextColor} font-medium`}>{item?.cardholderName + " - " + item?.creditCardNumber?.substr(-4)}</span>
                              </MenuItem>,
                              <Divider key={`${i}-Divider`} className="w-full" />
                            ]))
                          }
                        </Menu>
                      </>
                    )
                  }

                  {
                    (!isSecurityDepositedPaid && securityDepositAmount > 0) && (
                      <>
                        <Button variant="contained"
                          sx={{
                            backgroundColor: colorConfigs.btn.main.bg,
                            fontSize: "10px"
                          }}
                          onClick={shandleClick}
                        >
                          Authorize ${securityDepositAmount?.toFixed(2)} with Authorize
                          {
                            sopen
                              ? (
                                <span className={`material-symbols-outlined text-white text-[20px] font-extralight`}>
                                  keyboard_arrow_up
                                </span>
                              ) : (
                                <span className={`material-symbols-outlined text-white text-[20px] font-extralight`}>
                                  keyboard_arrow_down
                                </span>
                              )
                          }
                        </Button>

                        <Menu
                          id="basic-menu"
                          anchorEl={sanchorEl}
                          open={sopen}
                          onClose={shandleClose}
                          slotProps={{
                            paper: {
                              sx: {
                                width: 230,
                                backgroundColor: themeStyles.topBar.bg
                              }
                            }
                          }}
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "left",
                          }}
                          transformOrigin={{
                            vertical: "top",
                            horizontal: "left",
                          }}
                        >
                          {
                            creditCardList?.map((item: any, j: number) => ([
                              <MenuItem
                                key={`${j}-Item`}
                                sx={{ fontSize: "12px", marginBlock: "0px" }}
                                onClick={() => {
                                  if (!isCompletedOrCancelled) {
                                    if (securityDepositAmount > 0) {
                                      setConfirmData({
                                        title: 'Security Deposit',
                                        summary: 'Are you sure you want to pay?',
                                        confirmBtn: 'Yes',
                                        isConfirm: (callback: any) => {
                                          handleAuthorize(false, item?.id);
                                          callback();
                                        }
                                      });

                                      setConfirmPopup(true);

                                      shandleClose();
                                    } else {
                                      setConfirmData({
                                        title: 'Warning',
                                        summary: "You do not have Security Deposit Amount to Pay",
                                        confirmBtn: 'Ok',
                                        isConfirm: (callback: any) => {
                                          callback();
                                        }
                                      });

                                      setConfirmPopup(true);
                                    }
                                  }
                                }}
                              >
                                <span className={`${themeStyles.topBar.tailwindTextColor} font-medium`}>{item?.cardholderName + " - " + item?.creditCardNumber?.substr(-4)}</span>
                              </MenuItem>,
                              <Divider key={`${j}-Divider`} className="w-full" />
                            ]))
                          }
                        </Menu>
                      </>
                    )
                  }
                </>
              )
            }
          </div>

          {
            (
              (permissions?.disabledrefund || auth?.roles?.toLowerCase()?.trim() === "admin")
              && summaryData?.dateTimeCheckOut
              && summaryData?.dateTimeCheckIn
              && !isSecurityDepositedRefunded
              && summaryData?.outstandingBalance > 0
            ) && (
              <div className="w-full flex items-center gap-2.5 mt-4">
                <Button variant="contained"
                  sx={{
                    backgroundColor: "#007074",
                    fontSize: "10px"
                  }}
                  onClick={() => {
                    if (summaryData?.outstandingBalance > 0) {
                      setOpenSettledOutstandingDialog(true);
                    } else {
                      setConfirmData({
                        title: 'Warning',
                        summary: "You do not have any Outstanding Balance",
                        confirmBtn: 'Ok',
                        isConfirm: (callback: any) => {
                          callback();
                        }
                      });

                      setConfirmPopup(true);
                    }
                  }}
                >
                  Settle Outstanding Balance from Security Deposit
                </Button>
              </div>
            )
          }

          <div className="w-full flex items-center gap-2.5 mt-4">
            {
              (
                summaryData?.outstandingBalance > 0
              ) && (
                <Button variant="contained"
                  sx={{
                    backgroundColor: "#1DCD9F",
                    fontSize: "10px"
                  }}
                  onClick={() => {
                    if (!isCompletedOrCancelled) {
                      if (summaryData?.outstandingBalance > 0) {
                        setIsProcessPayment(true);
                        setProcessPaymentBox(true);
                      } else {
                        setConfirmData({
                          title: 'Warning',
                          summary: "You do not have any Outstanding Balance",
                          confirmBtn: 'Ok',
                          isConfirm: (callback: any) => {
                            callback();
                          }
                        });

                        setConfirmPopup(true);
                      }
                    }
                  }}
                >
                  Process Payment
                </Button>
              )
            }

            {
              (!isSecurityDepositedPaid && securityDepositAmount > 0) && (
                <Button variant="contained"
                  sx={{
                    backgroundColor: "#1DCD9F",
                    fontSize: "10px"
                  }}
                  onClick={() => {
                    if (!isCompletedOrCancelled) {
                      if (!isSecurityDepositedPaid) {
                        setIsProcessPayment(false);
                        setProcessPaymentBox(true);
                      } else {
                        setConfirmData({
                          title: 'Warning',
                          summary: "You do not have Security Deposit Amount to Pay",
                          confirmBtn: 'Ok',
                          isConfirm: (callback: any) => {
                            callback();
                          }
                        });

                        setConfirmPopup(true);
                      }
                    }
                  }}
                >
                  Process Security Deposit
                </Button>
              )
            }
          </div>

          <div className="mt-4 gap-2.5 flex">
            {
              (
                summaryData?.outstandingBalance > 0
              ) && (
                <Button variant="contained"
                  sx={{
                    backgroundColor: "#3E3F5B",
                    fontSize: "10px"
                  }}
                  onClick={() => {
                    if (!isCompletedOrCancelled) {
                      if (summaryData?.outstandingBalance > 0) {
                        setIsPaymentRequestType(true);
                        setOpenPaymentRequestPopup(true)
                      } else {
                        setConfirmData({
                          title: 'Warning',
                          summary: "You do not have any Outstanding Balance",
                          confirmBtn: 'Ok',
                          isConfirm: (callback: any) => {
                            callback();
                          }
                        });

                        setConfirmPopup(true);
                      }
                    }
                  }}
                >
                  Request Payment
                </Button>
              )
            }

            {
              (!isSecurityDepositedPaid && securityDepositAmount > 0)
              && (
                <Button variant="contained"
                  sx={{
                    backgroundColor: "#3E3F5B",
                    fontSize: "10px"
                  }}
                  onClick={() => {
                    if (!isCompletedOrCancelled) {
                      if (!isSecurityDepositedPaid) {
                        setIsPaymentRequestType(false);
                        setOpenPaymentRequestPopup(true)
                      } else {
                        setConfirmData({
                          title: 'Warning',
                          summary: "You do not have Security Deposit Amount to Pay",
                          confirmBtn: 'Ok',
                          isConfirm: (callback: any) => {
                            callback();
                          }
                        });

                        setConfirmPopup(true);
                      }
                    }
                  }}
                >
                  Request Security Deposit
                </Button>
              )
            }
          </div>

          {allPaymentRequestList?.length > 0 && (
            <div className="mb-[2.5rem]">
              <span className={`text-[14px] font-semibold inline-block mb-2 mt-10 ${themeStyles.main.textHeadingColor}`}>
                Payment Requests
              </span>

              <div
                className="overflow-x-auto"
                style={{
                  scrollbarWidth: 'thin',
                  WebkitOverflowScrolling: 'touch',
                }}
              >
                <div className="inline-block min-w-max">
                  <Divider className={`w-full ${themeStyles.divider.bg}`} />
                  <table className="min-w-full table-auto">
                    <tbody className="text-left">
                      <tr className={`border-b ${themeStyles.main.borderColor}`}>
                        <th className={`text-[12px] font-semibold whitespace-nowrap px-4 py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>#</th>
                        <th className={`text-[12px] font-semibold whitespace-nowrap px-4 py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Request Type</th>
                        <th className={`text-[12px] font-semibold whitespace-nowrap px-4 py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Amount</th>
                        <th className={`text-[12px] font-semibold whitespace-nowrap px-4 py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Email</th>
                        <th className={`text-[12px] font-semibold whitespace-nowrap px-4 py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Status</th>
                        <th className={`text-[12px] font-semibold whitespace-nowrap px-4 py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Payment Link</th>
                        <th className={`text-[12px] font-semibold whitespace-nowrap px-4 py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Due Date</th>
                        <th className={`text-[12px] font-semibold whitespace-nowrap px-4 py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Created At</th>
                        <th className={`text-[12px] font-semibold whitespace-nowrap px-4 py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Created By</th>
                      </tr>

                      {allPaymentRequestList?.map((item: any, index: number) => {
                        const statusColor = paymentRequestStatusColorCode?.find((color: any) => color?.label === item?.status?.trim()?.toLowerCase()) || {
                          colorBg: "#000000",
                          colorText: "#000000"
                        };

                        return (
                          <tr key={index} className={`border-b ${themeStyles.main.borderColor}`}>
                            <td className={`px-4 py-2 whitespace-nowrap text-xs font-medium text-blue-500 underline cursor-pointer ${themeStyles.main.textHeadingColor}`}
                              onClick={() => {
                                setOpenPaymentRequestDetailsPopup(true);
                                setPaymentRequestDetails(item);
                              }}>
                              {item?.id}
                            </td>

                            <td className={`px-4 py-2 whitespace-nowrap text-xs font-medium ${themeStyles.main.textHeadingColor}`}>
                              {item?.requestType}
                            </td>

                            <td className={`px-4 py-2 whitespace-nowrap text-xs font-medium ${themeStyles.main.textHeadingColor}`}>
                              ${parseFloat(item?.amount)?.toFixed(2)}
                            </td>

                            <td className={`px-4 py-2 whitespace-nowrap text-xs font-medium ${themeStyles.main.textHeadingColor}`}>
                              {item?.email}
                            </td>

                            <td className="px-4 py-2 whitespace-nowrap text-xs font-medium">
                              <span className={`px-[10px] py-[2px] rounded-xl border ${themeStyles.main.borderColor} ${statusColor.colorText} ${statusColor.colorBg}`}>
                                {item?.status}
                              </span>
                            </td>

                            <td className="px-4 py-2 whitespace-nowrap text-xs font-medium text-blue-500 cursor-pointer hover:underline"
                              onClick={() => {
                                if (showCopyPopup) {
                                  setShowCopyPopup(false);
                                }
                                navigator.clipboard.writeText(item?.paymentLink);
                                setShowCopyPopup(true);
                                setTimeout(() => setShowCopyPopup(false), 500);
                              }}
                            >
                              Click here to copy
                            </td>

                            <td className={`px-4 py-2 whitespace-nowrap text-xs font-medium ${themeStyles.main.textHeadingColor}`}>
                              {item?.dueDate
                                ? moment(
                                  new Date(item.dueDate.replaceAll("-", "/").split("T")[0])
                                ).format(dateFormat)
                                : ""}
                            </td>

                            <td className={`px-4 py-2 whitespace-nowrap text-xs font-medium ${themeStyles.main.textHeadingColor}`}>
                              {item?.createdAt
                                ? moment(new Date(item.createdAt)).format(dateFormat + " hh:mm a")
                                : ""}
                            </td>

                            <td className={`px-4 py-2 whitespace-nowrap text-xs font-medium ${themeStyles.main.textHeadingColor}`}>
                              {item?.createdBy}
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}

          <ProcessPaymentBox
            open={processPaymentBox}
            onClose={() => {
              setProcessPaymentBox(false);
              setIsProcessPayment(true);
            }}
            isCompletedOrCancelled={isCompletedOrCancelled}
            setPleaseWait={setPleaseWait}
            reservationId={reservationId}
            summaryData={summaryData}
            formattedCreatedAt={formattedCreatedAt}
            refreshTheSummary={refreshTheSummary}
            refreshThepayment={refreshThepayment}
            isProcessPayment={isProcessPayment}
            securityDepositAmount={securityDepositAmount}
          />

          <AddOfflinePayment
            open={offlinePaymentPopup}
            onClose={() => setOfflinePaymentPopup(false)}
            isCompletedOrCancelled={isCompletedOrCancelled}
            setPleaseWait={setPleaseWait}
            reservationId={reservationId}
            summaryData={summaryData}
            formattedCreatedAt={formattedCreatedAt}
            refreshTheSummary={refreshTheSummary}
            refreshThepayment={refreshThepayment}
            preferredDateFormat={preferredDateFormat}
            securityDepositAmount={securityDepositAmount}
          />

          {
            (permissions?.disabledrefund || auth?.roles?.toLowerCase()?.trim() === "admin")
            && (
              <PaymentDetailsPopup
                open={openPaymentDetailsPopup}
                onClose={() => {
                  setParticularPaymentDetails(null);
                  setOpenPaymentDetailsPopup(false);
                }}
                paymentDetails={particularPaymentDetails}
                creditCardList={creditCardList}
                setPleaseWait={setPleaseWait}
                formattedCreatedAt={formattedCreatedAt}
                isCompletedOrCancelled={isCompletedOrCancelled}
                isSecurityDepositedRefunded={isSecurityDepositedRefunded}
                reservationId={reservationId}
                summaryData={summaryData}
                refreshTheReservation={() => {
                  refreshTheSummary();
                  refreshThepayment();
                  refreshThRefund();
                }}
                refundList={refundList}
              />
            )
          }

          <PaymentRequest
            open={openPaymentRequestPopup}
            onClose={() => setOpenPaymentRequestPopup(false)}
            isCompletedOrCancelled={isCompletedOrCancelled}
            setPleaseWait={setPleaseWait}
            reservationId={reservationId}
            summaryData={summaryData}
            preferredDateFormat={preferredDateFormat}
            formattedCreatedAt={formattedCreatedAt}
            isPaymentRequestType={isPaymentRequestType}
            refreshThePaymentRequest={refreshThePaymentRequest}
          />

          <PaymentRequestDetails
            open={openPaymentRequestDetailsPopup}
            onClose={() => setOpenPaymentRequestDetailsPopup(false)}
            isCompletedOrCancelled={isCompletedOrCancelled}
            setPleaseWait={setPleaseWait}
            paymentRequestDetails={paymentRequestDetails}
            refreshThePaymentRequest={refreshThePaymentRequest}
          />

          {
            (
              (permissions?.disabledrefund || auth?.roles?.toLowerCase()?.trim() === "admin")
              && !isSecurityDepositedRefunded
            ) && (
              <SettledOutstandingBalance
                open={openSettledOutstandingDialog}
                onClose={() => setOpenSettledOutstandingDialog(false)}
                formattedCreatedAt={formattedCreatedAt}
                summaryData={summaryData}
                reservationId={reservationId}
                refreshTheReservation={() => {
                  refreshTheSummary();
                  refreshThepayment();
                  refreshThRefund();
                }}
                setPleaseWait={setPleaseWait}
                refundList={refundList}
                allPaymentList={allPaymentList}
              />
            )
          }
        </div>
      </div>

      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={showCopyPopup}
        autoHideDuration={1000}
        onClose={handleClose}
      >
        <Alert
          severity="success"
          variant="filled"
          sx={{ width: '100%' }}
        >
          Link copied
        </Alert>
      </Snackbar>
    </>
  );
}